import { IBundleItemsDetails } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import NextImage from "@/app/components/lib/NextImage";
import Price from "@/app/components/lib/Price";

export default function BundleItem({
  name,
  image_url,
  quantity,
  attribute,
  price,
  WithoutBorder,
}: IBundleItemsDetails & { WithoutBorder: boolean }) {
  return (
    <div
      className="product-bundle"
      style={WithoutBorder ? { border: "none" } : undefined}
    >
      <div className="product-bundle-image">
        <NextImage
          src={image_url}
          alt={name}
          width={96}
          height={96}
          className="image"
          objectFit="fill"
        />
      </div>
      <div className="product-bundle-info">
        <h4 className="product-bundle-title no-hover-effect m-0">{`${name} (X${quantity})`}</h4>

        {price && (
          <Price price={{ value: price, className: "product-bundle-price " }} />
        )}
        <div className=" d-flex flex-column gap-1">
          {Object.keys(attribute).map((key) => (
            <div className=" d-flex gap-1 align-items-center" key={key}>
              <div className="attr-key">{`${key} : `}</div>
              <div className="attr-value">{attribute[key]}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
